// Shared price helpers. They mirror the backend rules in
// backend/pricing_config.py so every page shows the number a firm will actually
// be charged, never "R0" / "RNaN" / "NaN AFS".

// A usable PRICE is a finite number greater than zero. Mirrors
// pricing_config._positive_price: the Admin Board sends Number("") === 0 when
// a price field is cleared, and the backend then falls back to the documented
// default. Booleans, strings, null, NaN and Infinity are rejected too.
export function positivePrice(value, fallback) {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : fallback
}

// Like positivePrice but zero is allowed (zero included AFS credits per seat
// is a legitimate setting; a price of R0 is not). Mirrors
// pricing_config._non_negative_number.
export function nonNegativeNumber(value, fallback) {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : fallback
}

// Whole rand amounts as "R295"; amounts with cents as "R299.50". Unlike
// Billing's R() this never rounds: Signup promises "you'll only ever be
// charged the exact amount above", so a price of 299.5 must not read as R300.
export function formatRand(n) {
  return Number.isInteger(n) ? `R${n.toLocaleString('en-ZA')}` : `R${n.toFixed(2)}`
}
